module.exports = __webpack_public_path__ + "static/media/unsaved.0a6a4023.svg";